import { useEffect } from 'react'
import { useForm } from 'react-hook-form/dist'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  FormulaireSchema,
  FormulaireSchemaType,
  MediaEnum,
} from '../validation/formulaire.schema';
import { useDispatch, useSelector } from 'react-redux'
import { fetchFormulaire, saveFormulaire } from '../../../Store/Formulaire/Actions'
import { IApplicationState } from '../../../Store';
import { domainToZodMapper } from './mappers/domain-to-zod.mapper';
import { IFormulaireFranceState } from '../../../Store/Formulaire/Types';

const defaultValues: FormulaireSchemaType = {
  spot: {
    spotLink: '',
    spotTitle: '',
    duration: '',
    brand: '',
    productName: '',
    productNature: '',
    declarant: '',
    idCreaCode: '',
    arppCodes: '',
    pubIdCodes: '',
  },
  works: [],
  first_diffusion: {
    media: MediaEnum.TV,
    broadcaster: '',
    dateTime: '',
  },
  declarant: {
    id: 0,
    last_name: '',
    first_name: '',
    company_name: '',
    last_edition_date: '',
  },
  should_send_to_sacem: false,
};

export const useFormulaire = (
  bucketId: number,
  fgpId: number,
  userGroupId: number,
  country: 'fr'
) => {
  const dispatch = useDispatch();
  const formulaire = useSelector(
    (state: IApplicationState) => state.formulaire[country]
  );

  const form = useForm<FormulaireSchemaType>({
    resolver: zodResolver(FormulaireSchema),
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (formulaire) {
      //sometimes strange stuff happens with the form state, so we need to wait for the next tick
      setTimeout(() => {
        const mappedFormulaire =
          domainToZodMapper.mapFormulaireToZodSchema(formulaire);
        if (mappedFormulaire) {
          form.reset(mappedFormulaire);
          form.clearErrors();
          Object.keys(mappedFormulaire).forEach((key) => {
            form.trigger(key);
          });
        }
      }, 1);
    }
  }, [formulaire]);

  useEffect(() => {
    if (bucketId && fgpId) {
      dispatch(fetchFormulaire({ fingerprint_list: [{ bucket_id: bucketId, fgp_id: fgpId }], user_group_id: userGroupId }));
    }
  }, [bucketId, fgpId]);

  return {
    form,
    isLoading: form.formState.isSubmitting,
    formulaire: formulaire as IFormulaireFranceState,
  };
};